import BackToPreviousPageButton from "../buttons/BackToPreviousPageButton";
import { Box, Divider, Grid, Stack, styled, Typography } from "@mui/material";

interface ContainerProps {
  border?: boolean;
}

const Container = styled("div")<ContainerProps>(({ theme, border = true }) => ({
  flex: 1,
  overflow: "auto",
  padding: theme.spacing(1),
  border: border ? "1px solid rgba(0, 0, 0, 0.25)" : "none",
  borderRadius: "5px",
  backgroundColor: "#fff",
}));

export default function SectionContainer({
  children,
  title,
  border,
  previousPageButtonLink,
  previousPageButtonTitle,
}: {
  children: any;
  title?: string;
  border?: boolean;
  previousPageButtonLink?: string;
  previousPageButtonTitle?: string;
}) {
  return (
    <Container border={border}>
      <Grid container direction="column" spacing={1}>
        {title && (
          <>
            <Grid item xs={12}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="h5">{title}</Typography>
                <Box flex={1} />
                {previousPageButtonLink && previousPageButtonTitle && (
                  <BackToPreviousPageButton
                    to={previousPageButtonLink}
                    title={previousPageButtonTitle}
                  />
                )}
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
}
